import React from "react";

export interface AccelaAuthPopupParams {
  clientId: string;
  agencyName: string;
  environment: string;
  scope: string;
  onAuthComplete?: (result: { code: string; state?: string }) => void;
  onError?: (error: any) => void;
}

/**
 * Opens the Accela OAuth popup and handles the message event.
 * Usage: Call openAccelaAuthPopup with the required params.
 */
export function openAccelaAuthPopup({
  clientId,
  agencyName,
  environment,
  scope,
  onAuthComplete,
  onError
}: AccelaAuthPopupParams) {
  const accelaLoginUrl = new URL("https://auth.accela.com/oauth2/authorize");
  accelaLoginUrl.searchParams.set("client_id", clientId);
  accelaLoginUrl.searchParams.set("agency_name", agencyName);
  accelaLoginUrl.searchParams.set("environment", environment);
  accelaLoginUrl.searchParams.set("redirect_uri", "https://localhost:9000/integrations/accela-civic/AccelaCallbackBridge");
  accelaLoginUrl.searchParams.set("scope", scope);
  accelaLoginUrl.searchParams.set("response_type", "code");

  const popup = window.open(
    accelaLoginUrl.toString(),
    "AccelaLoginPopup",
    "width=600,height=600,left=300,top=200"
  );

  function handleMessage(event: MessageEvent) {
    if (event.origin !== window.location.origin) return;
    if (event.data?.type === "ACCELA_AUTH") {
      popup?.close();
      if (onAuthComplete) {
        onAuthComplete({ code: event.data.code, state: event.data.state });
      }
      window.removeEventListener("message", handleMessage);
    }
  }

  window.addEventListener("message", handleMessage);

  // Optionally handle popup closed by user
  const popupInterval = setInterval(() => {
    if (popup && popup.closed) {
      clearInterval(popupInterval);
      window.removeEventListener("message", handleMessage);
      if (onError) onError(new Error("Popup closed by user"));
    }
  }, 500);
}
